// The current application coordinates were pre-registered in a B2C tenant.
export const apiConfig = `https://${process.env.REACT_APP_B2C_APP}.onmicrosoft.com/${process.env.REACT_APP_API_CLIENT_ID}/tasks.read`;